import React from "react";
import moment from "moment-timezone";
import { FormattedMessage } from "react-intl";
import { AeroDatePicker } from "./AeroDatePicker";

interface EffectiveDatePickerProps {
    disabled: boolean;
    effectiveDate: string;
    onDateChange: (value: string) => void;
}

export const EffectiveDatePicker = (props: EffectiveDatePickerProps) => {
    const { disabled, effectiveDate, onDateChange } = props;
    return (
        <>
            <div>
                <FormattedMessage id={"workspaceChanges.effectiveDateLabel"} /> <span className={"utcWarn"}>(UTC)</span>
            </div>
            <div>
                <AeroDatePicker
                    className={"datePicker"}
                    id={"effectiveDatePicker"}
                    timezone={"UTC"}
                    selectedDate={moment(effectiveDate).toDate()}
                    dateFormat={"yyyy-MM-dd"}
                    disabled={disabled}
                    onDateChange={(value) => onDateChange(value.toString())}
                    highlightAiracDates={true}
                />
            </div>
        </>
    );
};
